'use client';

import bacon001 from '@/assets/images/design-annotation/bacon001.jpg';
import bacon002 from '@/assets/images/design-annotation/bacon002.jpg';
import bacon006 from '@/assets/images/design-annotation/bacon006.jpg';
import bacon009 from '@/assets/images/design-annotation/bacon009.jpg';
import originalImage1 from '@/assets/images/design-annotation/original-image-1.png';
import originalImage2 from '@/assets/images/design-annotation/original-image-2.png';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { getImageLayoutSizes } from '@/utils/nextImage';
import { useState } from 'react';
import ImageDetailModal from '../ImageDetailModal/ImageDetailModal';
import NextImageView from '../NextImageView/NextImageView';
import styles from './DesignAnnotation.module.scss';

function DesignAnnotation() {
  const [selectedImageUrl, setSelectedImageUrl] = useState<string | null>(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleImageClick = (imageUrl: string) => {
    setSelectedImageUrl(imageUrl);
    setIsImageModalOpen(true);
  };

  const handleCloseImageModal = () => {
    setIsImageModalOpen(false);
    setSelectedImageUrl(null);
  };

  return (
    <div>
      <h2 className={`${utilsStyles.textBold} ${styles.sectionTitle}`}>ご購入前の確認事項</h2>
      <p className={`${utilsStyles.textMedium} ${styles.titleDescription}`}>
        作成したオリジナルグッズは完全受注生産のため、
        <span className={utilsStyles.redColor}>キャンセル・返品交換はできかねます。</span>
        下記生産上の特性をご了承のうえ、ご購入ください。なお、こちらの注意事項はFAQからいつでもご確認頂けます。
      </p>
      <p className={`${utilsStyles.textMedium} ${utilsStyles.mtXSmall}`}>
        ・商品デザインはイメージです。実際の商品とは異なる場合があります。あらかじめご了承ください。
        <br />
        ・各アイテム、決まった位置にジャンプLABのロゴが印刷されます。デザイン確認画面でご確認いただけます。
        <br />
        ・コミックス刊行当時の画像を使用しているため、画像上のかすれ・汚れなども印刷されてしまう場合がございます。
        <br />
        ・細かい文字の潰れや、細い線のかすれ、モアレ（干渉縞）が発生する場合がございます。
        <br />
        ・印刷、生産工程上、サイズ・色・形状・プリント位置に個体差が生じる場合がございます。
      </p>
      <h3
        className={`${utilsStyles.textLarge} ${utilsStyles.textLeft} ${utilsStyles.textBold} ${styles.subSectionTitle}`}
      >
        印刷のにじみについて
      </h3>
      <p className={`${utilsStyles.textMedium} ${utilsStyles.mtXSmall}`}>
        ハンドタオルは昇華転写印刷（インクを染み込ませる印刷技術）の為、印刷のにじみが多少発生する場合がございます。
      </p>
      <div className={`${utilsStyles.mtSmall} ${styles.imageRow}`}>
        <div className={utilsStyles.centeredVertical}>
          <p className={`${utilsStyles.textSmall} ${styles.imageTitle}`}>画像例</p>
          <div
            className={`${utilsStyles.fullWidth} ${utilsStyles.mtXSmall} ${styles.imageContainer} ${styles.clickableImage}`}
            onClick={() => handleImageClick(originalImage1.src)}
          >
            <NextImageView
              src={originalImage1.src}
              alt='画像例'
              fill
              sizes={getImageLayoutSizes({ sp: '25vw', pc: '340px' })}
              objectFit='contain'
            />
          </div>
        </div>
        <div className={utilsStyles.centeredVertical}>
          <p className={`${utilsStyles.textSmall} ${styles.imageTitle}`}>ハンドタオル</p>
          <div
            className={`${utilsStyles.fullWidth} ${utilsStyles.mtXSmall} ${styles.imageContainer} ${styles.clickableImage}`}
            onClick={() => handleImageClick(bacon006.src)}
          >
            <NextImageView
              src={bacon006.src}
              alt='ハンドタオル'
              fill
              sizes={getImageLayoutSizes({ sp: '25vw', pc: '340px' })}
              objectFit='contain'
            />
          </div>
        </div>
      </div>
      <h3
        className={`${utilsStyles.textLarge} ${utilsStyles.textLeft} ${utilsStyles.textBold} ${styles.subSectionTitle}`}
      >
        印刷のかすれ・つぶれについて
      </h3>
      <p className={`${utilsStyles.textMedium} ${utilsStyles.mtXSmall}`}>
        小さな絵柄、細かい絵柄、セリフ・漢字の読み仮名などは、かすれ・つぶれが発生する場合がございます。
      </p>
      <h3
        className={`${utilsStyles.textLarge} ${utilsStyles.textLeft} ${utilsStyles.textBold} ${styles.subSectionTitle}`}
      >
        モアレ（干渉縞）について
      </h3>
      <p className={`${utilsStyles.textMedium} ${utilsStyles.mtXSmall}`}>
        モアレの発生を極力おさえるために、一部画像には処理を行っておりますが、絵柄によってはモアレが発生してしまう場合がございます。また、本処理によって線やトーンなどが薄くなってしまう場合がございます。
      </p>
      <div className={`${utilsStyles.mtSmall} ${styles.imageRow}`}>
        <div className={utilsStyles.centeredVertical}>
          <p className={`${utilsStyles.textSmall} ${styles.imageTitle}`}>画像例</p>
          <div
            className={`${utilsStyles.fullWidth} ${utilsStyles.mtXSmall} ${styles.imageContainer} ${styles.clickableImage}`}
            onClick={() => handleImageClick(originalImage2.src)}
          >
            <NextImageView
              src={originalImage2.src}
              alt='画像例'
              fill
              sizes={getImageLayoutSizes({ sp: '25vw', pc: '340px' })}
              objectFit='contain'
            />
          </div>
        </div>
        <div className={utilsStyles.centeredVertical}>
          <p className={`${utilsStyles.textSmall} ${styles.imageTitle}`}>
            ヘビーウエイトTシャツ
            <br />
            （モアレ発生）
          </p>
          <div
            className={`${utilsStyles.fullWidth} ${utilsStyles.mtXSmall} ${styles.imageContainer} ${styles.clickableImage}`}
            onClick={() => handleImageClick(bacon002.src)}
          >
            <NextImageView
              src={bacon002.src}
              alt='印刷テスト（モアレ発生）'
              fill
              sizes={getImageLayoutSizes({ sp: '25vw', pc: '340px' })}
              objectFit='contain'
            />
          </div>
        </div>
        <div className={utilsStyles.centeredVertical}>
          <p className={`${utilsStyles.textSmall} ${styles.imageTitle}`}>着用画像</p>
          <div
            className={`${utilsStyles.fullWidth} ${utilsStyles.mtXSmall} ${styles.imageContainer} ${styles.clickableImage}`}
            onClick={() => handleImageClick(bacon001.src)}
          >
            <NextImageView
              src={bacon001.src}
              alt='着用画像'
              fill
              sizes={getImageLayoutSizes({ sp: '25vw', pc: '340px' })}
              objectFit='contain'
            />
          </div>
        </div>
      </div>

      <h3
        className={`${utilsStyles.textLarge} ${utilsStyles.textLeft} ${utilsStyles.textBold} ${styles.subSectionTitle}`}
      >
        コマやキャラクターに付随する白フチについて
      </h3>
      <p className={`${utilsStyles.textMedium} ${utilsStyles.mtXSmall}`}>
        以下の商品では、白い下地の上に印刷をするDTF転写印刷を採用しています
      </p>
      <p className={`${utilsStyles.textMedium} ${utilsStyles.mtXSmall}`}>
        <strong>【DTF転写印刷対象商品】</strong>
        <br />
        スタンダードTシャツ、ヘビーウエイトTシャツ、ロングスリーブTシャツ、キッズTシャツ、デイリーサコッシュ、ランチトートバッグ、トートバッグ、ビッグトートバッグ、ニュースペーパーバッグ、スタンダードスウェット、プルオーバーパーカー
      </p>
      <p className={`${utilsStyles.textMedium} ${utilsStyles.mtXSmall}`}>
        濃色生地では黒いコマやキャラクターの輪郭・枠線をはっきりと表現するため、線の外側に白いフチをつけており、コマやキャラクターの周りに細い余白のような形で印刷されます。
        淡色生地ではフチはつけておりませんが、白い下地がわずかにはみ出す場合がございます。
      </p>
      {/* 画像拡大表示モーダル */}
      <ImageDetailModal isOpen={isImageModalOpen} onClose={handleCloseImageModal} imageUrl={selectedImageUrl} />

      <h3
        className={`${utilsStyles.textLarge} ${utilsStyles.textLeft} ${utilsStyles.textBold} ${styles.subSectionTitle}`}
      >
        生地色のコマへの影響について
      </h3>
      <p className={`${utilsStyles.textMedium} ${utilsStyles.mtXSmall}`}>
        DTF転写で印刷されるコマは、生地色の影響を多少受けます。印刷した箇所は完全には不透明にならず、「インクの色」と「生地の色」が合わさって見えるため、同じコマでも生地の色により差異が生じる場合がございます。
      </p>
      <div className={`${utilsStyles.centeredVertical} ${utilsStyles.mtXSmall}`}>
        <p className={`${utilsStyles.textSmall} ${styles.imageTitle}`}>
          画像例
          <br />
          左からホワイト、ブラック、レッド、ネイビー、ライトブルー、デイジー（黄）、ライトピンク
        </p>
        <div
          className={`${utilsStyles.fullWidth} ${utilsStyles.mtXSmall} ${styles.imageContainerWide} ${styles.clickableImage}`}
          onClick={() => handleImageClick(bacon009.src)}
        >
          <NextImageView
            className={styles.imageHeightAuto}
            src={bacon009.src}
            alt='生地色のコマへの影響'
            width={1080}
            height={423}
            fill={false}
            sizes={getImageLayoutSizes({ sp: '90vw', pc: '800px' })}
            objectFit='contain'
          />
        </div>
      </div>
    </div>
  );
}

export default DesignAnnotation;
